declare global {
    interface Window {
        dataLayer?: unknown[];
        gtag?: (...args: unknown[]) => void;
    }
}

export const trackPageView = (pagePath: string) => {
    if (typeof window === "undefined" || !window.gtag) return;

    window.gtag("event", "page_view", {
        page_path: pagePath,
        page_location: `${window.location.origin}${window.location.pathname}${pagePath}`,
    });
};

export const trackEvent = (name: string, params?: Record<string, unknown>) => {
    if (typeof window === "undefined" || !window.gtag) return;

    window.gtag("event", name, params);
};
